import { c as _c } from "react-compiler-runtime";
import { registerQuery, registerMutation, useMutation, useQuery } from 'data-fetching-client';
import { useCallback } from 'react';
import { getLocalStore } from '../utils/superstore';
export const READ_LOCAL_STORE_FIELD_NAME = 'listingliblocalStoreRead';
export const READ_LOCAL_STORE = registerQuery({
  fieldName: READ_LOCAL_STORE_FIELD_NAME,
  args: ['key'],
  fetcher({
    key
  }) {
    return getLocalStore().get(key).then(value => {
      return {
        key,
        value
      };
    });
  }
});
export const WRITE_LOCAL_STORE_FIELD_NAME = 'listingliblocalStoreWrite';
export const WRITE_LOCAL_STORE = registerMutation({
  fieldName: WRITE_LOCAL_STORE_FIELD_NAME,
  args: ['key', 'value'],
  fetcher({
    key,
    value
  }) {
    return getLocalStore().set(key, value).then(result => {
      return {
        key,
        value: result
      };
    });
  }
});
export function useReadLocalStore(key, options) {
  "use memo";

  var _queryResult$data;
  const $ = _c(9);
  let t0;
  if ($[0] !== key || $[1] !== options) {
    t0 = {
      key,
      options
    };
    $[0] = key;
    $[1] = options;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== options || $[4] !== t0) {
    t1 = Object.assign({
      variables: t0
    }, options);
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const queryResult = useQuery(READ_LOCAL_STORE, t1);
  const t2 = (_queryResult$data = queryResult.data) === null || _queryResult$data === void 0 ? void 0 : _queryResult$data[READ_LOCAL_STORE_FIELD_NAME];
  let t3;
  if ($[6] !== queryResult || $[7] !== t2) {
    t3 = Object.assign({}, queryResult, {
      data: t2
    });
    $[6] = queryResult;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
export function useWriteLocalStore() {
  "use memo";

  var _mutationResult$data;
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      optimisticResponse(variables) {
        return {
          [WRITE_LOCAL_STORE_FIELD_NAME]: {
            key: variables.key,
            value: variables.value
          }
        };
      },
      update(cache, t1) {
        const {
          data
        } = t1;
        if ((data === null || data === void 0 ? void 0 : data[WRITE_LOCAL_STORE_FIELD_NAME].value) === null) {
          return;
        }
        cache.writeQuery({
          query: READ_LOCAL_STORE,
          variables: {
            key: data === null || data === void 0 ? void 0 : data[WRITE_LOCAL_STORE_FIELD_NAME].key
          },
          data: {
            [READ_LOCAL_STORE_FIELD_NAME]: data === null || data === void 0 ? void 0 : data[WRITE_LOCAL_STORE_FIELD_NAME]
          }
        });
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [trigger, mutationResult] = useMutation(WRITE_LOCAL_STORE, t0);
  let t1;
  if ($[1] !== trigger) {
    t1 = t2 => {
      const {
        key,
        value
      } = t2;
      return trigger({
        variables: {
          key,
          value
        }
      });
    };
    $[1] = trigger;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const triggerMutation = t1;
  const t2 = (_mutationResult$data = mutationResult.data) === null || _mutationResult$data === void 0 ? void 0 : _mutationResult$data[WRITE_LOCAL_STORE_FIELD_NAME];
  let t3;
  if ($[3] !== mutationResult || $[4] !== t2) {
    t3 = Object.assign({}, mutationResult, {
      data: t2
    });
    $[3] = mutationResult;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3 || $[7] !== triggerMutation) {
    t4 = [triggerMutation, t3];
    $[6] = t3;
    $[7] = triggerMutation;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}